// extracted by mini-css-extract-plugin
export default {"container":"styles-module__container__src-labstep-web-components-File-Snapgene-_yYZ6L","image":"styles-module__image__src-labstep-web-components-File-Snapgene-_ub4jq"};